import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import notify from '../../shared/feedback/notifications';
import { Button, Row, Col, FormGroup, Checkbox } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import * as Features from '../../shared/Features';
import LogsModal from '../logs/LogsModal';
import * as Actions from './Actions';
import Se360UserList from './Se360UserList';
import Se360UserModal from './Se360UserModal';
import SpecialAuthorizationsModal from './specialauthorizations/SpecialAuthorizationsModal';

class Se360UsersPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            shouldShowCreateUpdateModal: false,
            shouldShowSpecialAuthorizationsModal: false,
            showLogsModal: false,
            showRemoved: false,
            userId: -1
        };

        this.toggleCreateUpdateModal = this.toggleCreateUpdateModal.bind(this);
        this.openCreateModal = this.openCreateModal.bind(this);
        this.openEditModal = this.openEditModal.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.openSpecialAuthorizationsModal = this.openSpecialAuthorizationsModal.bind(this);
        this.closeSpecialAuthorizationsModal = this.closeSpecialAuthorizationsModal.bind(this);
        this.toggleLogsModal = this.toggleLogsModal.bind(this);
        this.toggleShowRemoved = this.toggleShowRemoved.bind(this);
        this.restoreUser = this.restoreUser.bind(this);
    }

    componentDidMount(): void {
        this.props.actions.list().catch((error: any) => handleError(error));
    }

    openCreateModal(): void {
        this.setState({ userId: -1 });
        this.toggleCreateUpdateModal();
    }

    openEditModal(id: number): void {
        this.setState({ userId: id });
        this.toggleCreateUpdateModal();
    }

    toggleCreateUpdateModal() {
        this.setState({
            shouldShowCreateUpdateModal: !this.state.shouldShowCreateUpdateModal
        });
    }

    openSpecialAuthorizationsModal(id: number): void {
        this.setState({ userId: id });
        this.setState({ shouldShowSpecialAuthorizationsModal: true });
    }

    closeSpecialAuthorizationsModal(): void {
        this.setState({ userId: -1 });
        this.setState({ shouldShowSpecialAuthorizationsModal: false });
    }

    deleteUser(id: number): any {
        return this.props.actions
            .delete(id)
            .then(() => {
                notify.success(Translate('se360-users/notification/user-deleted'));
            })
            .catch((error: any) => handleError(error));
    }

    restoreUser(id: number): any {
        return this.props.actions
            .restore(id)
            .then(() => {
                notify.success(Translate('se360-users/notification/user-restored'));
            })
            .catch((error: any) => handleError(error));
    }

    toggleLogsModal(id?: number) {
        this.setState({ showLogsModal: !this.state.showLogsModal, userId: id });
    }

    toggleShowRemoved() {
        this.setState({ showRemoved: !this.state.showRemoved });
    }

    render() {
        return (
            <div>
                <h1>{Translate('se360users/page/title/se360users')}</h1>
                <Row>
                    <Col md={3} className="no-label">
                        <FormGroup>
                            <Checkbox
                                name="showRemoved"
                                checked={this.state.showRemoved}
                                onChange={this.toggleShowRemoved}
                            >
                                <span>
                                    {Translate('se360users/page/input-label/include-removed')}
                                </span>
                            </Checkbox>
                        </FormGroup>
                    </Col>
                    <Col md={9}>
                        {Features.hasFeature(Features.CreateSe360Users, this.props.user) && (
                            <Button
                                bsSize="large"
                                className="pull-right"
                                onClick={this.openCreateModal}
                                bsStyle="success"
                            >
                                {Translate('se360users/page/button-label/add-new-se360-user')}
                            </Button>
                        )}
                    </Col>
                </Row>
                {this.state.shouldShowCreateUpdateModal && (
                    <Se360UserModal
                        editId={this.state.userId}
                        shouldShowModal={this.state.shouldShowCreateUpdateModal}
                        closeModal={this.toggleCreateUpdateModal}
                    />
                )}
                {this.state.shouldShowSpecialAuthorizationsModal && (
                    <SpecialAuthorizationsModal
                        userId={this.state.userId}
                        shouldShowModal={this.state.shouldShowSpecialAuthorizationsModal}
                        closeModal={this.closeSpecialAuthorizationsModal}
                    />
                )}
                {this.state.showLogsModal && (
                    <LogsModal
                        id={this.state.userId}
                        type="UserId"
                        shouldShowModal={this.state.showLogsModal}
                        closeModal={this.toggleLogsModal}
                    />
                )}
                <Se360UserList
                    items={this.props.se360Users}
                    loggedInUser={this.props.user}
                    beginEdit={this.openEditModal}
                    delete={this.deleteUser}
                    handleSpecialAuthorizations={this.openSpecialAuthorizationsModal}
                    showLogs={this.toggleLogsModal}
                    showRemoved={this.state.showRemoved}
                    restoreUser={this.restoreUser}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        se360Users: state.se360Users.list,
        user: state.user,
        site: state.site
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            list: () => dispatch(Actions.list()),
            delete: (id: number) => dispatch(Actions.deleteSe360User(id)),
            restore: (id: number) => dispatch(Actions.restoreSe360User(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Se360UsersPage));
